import Vue from 'vue';
import VueResource from 'vue-resource';

Vue.use(VueResource);

export default { }



// WEBPACK FOOTER //
// ./client/resources/index.js